function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@emotion/core/node_modules/@babel/runtime/helpers/inheritsLoose.js
// module id = 86
// module chunks = 0